import { BaseEvent } from "@/api/ws/events/BaseEvent";

export type FileTypeChangedEventPayload = {
  id: number;
  file_type?: string | null;
};

export default class FileTypeChangedEvent extends BaseEvent<FileTypeChangedEventPayload> {
  name = ".file_type_changed";
}
